import {AfterViewInit, Directive, ElementRef} from '@angular/core';

declare const $: any;

@Directive({
    selector: '[site-carousel]'
})
export class SiteCarouselDirective implements AfterViewInit {


    constructor(private el: ElementRef) {
    }

    ngAfterViewInit() {
        const elem = $(this.el.nativeElement);
        setTimeout(_ => {
            elem.carousel();
            elem.off('click').on('click', '.item-point', function () {
                const indexSlide = $(this).data('slide-to');
                elem.carousel(indexSlide);
            });
        }, 500);

    }
}



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/site-carousel.directive.ts